/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js/auto'
import { ChartWrapper } from './chartUtils.js'

export const Pie = ({ data, title }) => {
  const chartRef = useRef(null)

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d')
    const pieChart = new Chart(ctx, {
      type: 'pie',
      data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right'
          }
        }
      }
    })

    return () => pieChart.destroy()
  }, [data])

  return (
      <ChartWrapper title={title}>
        <canvas ref={chartRef}></canvas>
      </ChartWrapper>
  )
}
